/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Embed_Export_Failed_ToastInputs */

const en_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio embed export failed: ${i?.error}`)
};

const fr_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l'exportation de l'intégration audio : ${i?.error}`)
};

const de_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio-Einbettungs-Export fehlgeschlagen: ${i?.error}`)
};

const it_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione dell'incorporamento audio non riuscita: ${i?.error}`)
};

const ru_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка экспорта аудиофайла: ${i?.error}`)
};

const es_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al exportar el audio incrustado: ${i?.error}`)
};

const zh_cn2_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音频嵌入导出失败：${i?.error}`)
};

const ja_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音声埋め込みのエクスポートに失敗しました: ${i?.error}`)
};

const hi_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो एम्बेड निर्यात विफल: ${i?.error}`)
};

const pt_pt2_audio_embed_export_failed_toast = /** @type {(inputs: Audio_Embed_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na exportação do áudio incorporado: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Audio embed export failed: {error}" |
*
* @param {Audio_Embed_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_failed_toast = /** @type {((inputs: Audio_Embed_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_failed_toast(inputs)
	if (locale === "de") return de_audio_embed_export_failed_toast(inputs)
	if (locale === "it") return it_audio_embed_export_failed_toast(inputs)
	if (locale === "ru") return ru_audio_embed_export_failed_toast(inputs)
	if (locale === "es") return es_audio_embed_export_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_failed_toast(inputs)
	if (locale === "ja") return ja_audio_embed_export_failed_toast(inputs)
	if (locale === "hi") return hi_audio_embed_export_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_failed_toast(inputs)
	return en_audio_embed_export_failed_toast(inputs)
});